import React from 'react';
import PropTypes from 'prop-types';
import FormField from '../FormField/FormField';
import MaterialFormGroup from '@material-ui/core/FormGroup';

const FormGroup = ({ className, label, children }) =>
    <FormField
        className={className}
        label={label}>
        <MaterialFormGroup>{ children }</MaterialFormGroup>
    </FormField>;

FormGroup.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
};

FormGroup.defaultProps = {
    label: ''
};

export default FormGroup;
